import {ViolationTargetModel} from './ViolationTarget.model';
import {
  Violation,
  Severity,
  V2Violation,
  ViolationSeverity as SdkV2ViolationSeverity,
} from '@wix/auto_sdk_ecom_cart-v-2';

export class ViolationModel {
  public severity: ViolationSeverity;
  public target: ViolationTargetModel;
  public description: string;

  constructor(params: ViolationModel) {
    this.severity = params.severity;
    this.target = params.target;
    this.description = params.description;
  }

  public static fromCartV1(violation: Violation) {
    return new ViolationModel({
      severity: severityMap(violation.severity as Severity),
      target: ViolationTargetModel.fromCartV1(violation.target),
      description: violation.description,
    });
  }
  public static fromCartV2Old(violation: Violation): ViolationModel {
    return new ViolationModel({
      severity: severityMap(violation.severity as Severity),
      target: ViolationTargetModel.fromCartV2(violation.target),
      description: violation.description,
    });
  }
  public static fromCartV2(violation: V2Violation): ViolationModel {
    return new ViolationModel({
      severity:
        violation.severity === SdkV2ViolationSeverity.ERROR ? ViolationSeverity.error : ViolationSeverity.warning,
      target: ViolationTargetModel.fromCartV2(violation.customValidationData.target),
      description: violation.description,
    });
  }
}

const severityMap = (severity: Severity) => {
  const map: Record<Severity, ViolationSeverity> = {
    [Severity.ERROR]: ViolationSeverity.error,
    [Severity.WARNING]: ViolationSeverity.warning,
  };

  return map[severity];
};

export enum ViolationSeverity {
  error = 'ERROR',
  warning = 'WARNING',
}
